import { BehaviorSubject } from "rxjs";
import { getFirst, getStorage, setStorage } from "@src/utils/dom";
import { siteArticleIdnAttr } from "@shared/constants";

const storageAnonymousLabel = "ANONYMOUS-label";

function anonymousName(text: string) {
  return text.trim().substring(0, 20).replace(/[<>]/g, "");
}

export function setAnonymousName(text: string) {
  anonymousLabel.current = anonymousName(text);
  setStorage(storageAnonymousLabel, anonymousLabel.current);
}

export const pageArticleAuthorSubject = new BehaviorSubject<boolean>(false);
export const pageAuthorizedSubject = new BehaviorSubject<boolean>(false);
export const pageScrolledSubject = new BehaviorSubject<boolean>(false);

export const pageArticleIdn = +(getFirst(`[${siteArticleIdnAttr}]`)?.dataset.number ?? 0);
export const anonymousLabel = { current: anonymousName(getStorage(storageAnonymousLabel) || "") };
